import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const DeleteConnection = new ReduxAsyncAction<'DELETE_CONNECTION', { machineName: string; credentialId: string }, void>(
  'DELETE_CONNECTION'
);
DeleteConnection.registerRequest(({ machineName, credentialId }) => {
  return dash_api.delete(`/v1/ad-network/${machineName}/connections/${credentialId}`).then(({ data }) => {
    return data;
  });
});
export const DELETE_CONNECTION = DeleteConnection.actionNamespaceConstants;
export const deleteConnection = DeleteConnection.request;

export type DeleteConnectionAction = Action<typeof DELETE_CONNECTION.response>;
